export default __webpack_public_path__ + "static/media/2_0030.0c0292e5.webp";